module.exports = __webpack_public_path__ + "img/Location.5ce5a8ec.svg";